import { Platform } from 'react-native';
import { type AppearanceParams } from '@stripe/stripe-react-native';

import { getEnvVars } from '@order/utils';

const merchantCountryCode = 'US';
export const stripePublicKey = getEnvVars().STRIPE_PUBLIC_KEY;
export const merchantDisplayName = 'sweetgreen';
export const returnURL = 'sweetgreen-order://bag';
export const currencyCode = 'usd';
export const setupFutureUsage = 'OffSession' as const;
export const paymentMethodTypes = ['card'];
export const paymentMethodTypesWithCashApp = ['card', 'cashapp'];
export const walletConfig = { currencyCode, merchantCountryCode };
export const googlePayConfig = {
  ...walletConfig,
  testEnv: stripePublicKey?.startsWith('pk_test'),
};
export const paymentMethodOptions = {
  setupFutureUsageValues: {
    card: 'OffSession',
  },
};
export const NO_PAYMENT_METHOD_NEEDED = 'NO_PAYMENT_METHOD_NEEDED';

export const stripeAppearance: AppearanceParams = {
  ...(Platform.OS === 'ios'
    ? {
        font: {
          family: 'SweetSansText-Regular',
        },
      }
    : {}),
  colors: {
    light: {
      primary: '#00473C',
      background: '#F8F7F0',
      componentBackground: '#F8F7F0',
      componentBorder: '#F8F7F0',
      componentDivider: '#F8F7F0',
      primaryText: '#0E150E',
      secondaryText: '#484D48',
      componentText: '#484D48',
      placeholderText: '#BDBDB1',
      icon: '#00473C',
      error: '#AB3726',
    },
    dark: {
      primary: '#00473C',
      background: '#F8F7F0',
      componentBackground: '#F8F7F0',
      componentBorder: '#F8F7F0',
      componentDivider: '#F8F7F0',
      primaryText: '#0E150E',
      secondaryText: '#484D48',
      componentText: '#484D48',
      placeholderText: '#BDBDB1',
      icon: '#00473C',
      error: '#AB3726',
    },
  },
  shapes: {
    borderRadius: 8,
    borderWidth: 1,
    shadow: {
      color: '#000000',
      opacity: 0.1,
      offset: {
        x: 0,
        y: 2,
      },
      blurRadius: 4,
    },
  },
  primaryButton: {
    shapes: {
      borderRadius: 24,
      borderWidth: 1,
    },
    colors: {
      light: {
        background: '#00473C',
        text: '#F8F7F0',
        border: '#0E150E',
      },
      dark: {
        background: '#00473C',
        text: '#F8F7F0',
        border: '#0E150E',
      },
    },
  },
  embeddedPaymentElement: {
    row: {
      style: 'flatWithRadio' as never,
      flat: {
        separatorColor: {
          light: '#F8F7F0',
          dark: '#F8F7F0',
        },
        checkmark: {
          color: {
            light: '#52775B',
            dark: '#52775B',
          },
        },
        radio: {
          selectedColor: {
            light: '#484D48',
            dark: '#484D48',
          },
          unselectedColor: {
            light: '#52775B',
            dark: '#52775B',
          },
        },
      },
    },
  },
};
